import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var LabelApi = /** @class */ (function () {
    function LabelApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    LabelApi.initialize = function (basePath, fetchApi) {
        if (!LabelApi.instance) {
            LabelApi.instance = new LabelApi(basePath, fetchApi);
        }
        return LabelApi.instance;
    };
    LabelApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1LabelsApi(new Configuration(config));
    };
    return LabelApi;
}());
export { LabelApi };
